@if (canShow) {
  @if (!_router.url.includes('about')) {
    <app-header></app-header>
  }
  <router-outlet></router-outlet>
  @if (!_router.url.includes('about')) {
    <app-footer></app-footer>
  }
}




